class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  onCartUpdate() {
    fetch('/cart?section_id=main-cart-items')
      .then((response) => response.text())
      .then((responseText) => {
        // announcement();
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        this.innerHTML = sourceQty.innerHTML;
    
      })
      .catch(e => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = 
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = 
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          // announcement();
        }));
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items'});
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        // errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    // this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
      constructor() {
        super();

      this.addEventListener('change', debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, ON_CHANGE_DEBOUNCE_TIMER))
      }
  });
};
function announcement(){
  $('.announcements_slider').flickity({
  // options
 contain: true,
freeScroll: true,
pageDots: false,
    autoPlay: true,
    fullscreen: true,
wrapAround: true
});
}
// announcement();


function carthtmldata(){
  $.ajax({
    type: 'GET', 
    url: '/cart',
    dataType: 'html',
    success: function(cart_html) {
      var cartdrawer_content = $(cart_html).find('.cart-drawer').html();
      $('.cart-drawer').html(cartdrawer_content);
      // announcement();
      var cart_count = $(cart_html).find('.cart-count-bubble span[aria-hidden="true"]').html();
      $('.cart-count-bubble span[aria-hidden="true"]').html(cart_count);
      
    }
  });
}



$(document).on('click', '.cart-item-edit', function(event){
event.preventDefault();
var pro_id = $(this).attr('data-proId');
var option1 = $(this).attr('data-option1');
var option2 = $(this).attr('data-option2');
// var option3 = $(this).attr('data-option3');
$('.upsell-options[data-productid="'+pro_id+'"] [name="option1"]').val(option1).trigger('change');
$('.upsell-options[data-productid="'+pro_id+'"] [name="option2"]').val(option2);
// $('.upsell-options[data-productid="'+pro_id+'"] [name="option3"]').val(option3);
$('.upsell-options[data-productid="'+pro_id+'"]').addClass('active cart-edit');
$('.upsell-options-overlay').addClass('active');
});
$(document).on('click', '.upsell_vriant_btn', function(event){
event.preventDefault();
 var pro_id = $(this).attr('data-proId');
$('.upsell-options[data-productid="'+pro_id+'"]').addClass('active');
$('.upsell-options-overlay').addClass('active');
});

function changeOptions2(option1, p_id) {
   $('[data-productid="' + p_id + '"] [name="option2"]').html('');
  $('#product-select-' + p_id + ' option').each(function(index) {
    var data_title = $(this).attr('data-title');
    if (data_title.includes(option1)) {
      var splitArray = data_title.split(" / ");
      var valueAtIndex2 = splitArray[1];
       $('[data-productid="' + p_id + '"] [name="option2"]').append('<option value="' + valueAtIndex2 + '">' + valueAtIndex2 + '</option>');
      // console.log(valueAtIndex2);
    }
  });
} 
$(document).on('click', '.upsell-options-overlay', function(){
$('.upsell-options').removeClass('active cart-edit');
$('.upsell-options-overlay').removeClass('active');
});

$(document).on('click', '.cart-drawer__overlay', function(){
$('.upsell-options').removeClass('active cart-edit');
$('.upsell-options-overlay').removeClass('active');
});

$(document).on('change', '[name="option1"]', function(){
changeOptions2($(this).val(),$(this).parents('.upsell-options').attr('data-productid'));
setTimeout(function() {
var option1 = $(this).parents('.upsell-options').find('[name="option1"]').val();
var option2 = $(this).parents('.upsell-options').find('[name="option2"]').val();
var option3 = $(this).parents('.upsell-options').find('[name="option3"]').val();
if(option3 != undefined){
var option = option1 +' / '+ option2 +' / '+ option3;
}else if(option2 != undefined){
var option = option1 +' / '+ option2;
}
else if(option1 != undefined){
var option = option1;
}
var id = $(this).parents('.upsell-options').find('.select option[data-title="'+option+'"]').attr('value');
var price = $(this).parents('.upsell-options').find('.select option[data-title="'+option+'"]').attr('data-price');
var img = $(this).parents('.upsell-options').find('.select option[data-title="'+option+'"]').attr('data-img');
$(this).parents('.upsell-options').find('.upsell-options-variant').text(option);
$(this).parents('.upsell-options').find('.upsell-options-prices .price').text(price);
$(this).parents('.upsell-options').find('.image img').attr('src', img);
$(this).parents('.upsell-options').find('[name="id"]').val(id);
}, 2000);
});
$(document).on('change', '[name="option2"]', function(){
var option1 = $(this).parents('.upsell-options').find('[name="option1"]').val();
var option2 = $(this).parents('.upsell-options').find('[name="option2"]').val();
var option3 = $(this).parents('.upsell-options').find('[name="option3"]').val();
if(option3 != undefined){
var option = option1 +' / '+ option2 +' / '+ option3;
}else if(option2 != undefined){
var option = option1 +' / '+ option2;
}
else if(option1 != undefined){
var option = option1;
}
$(this).parents('.upsell-options').find('.upsell-options-variant').text(option);
var id = $(this).parents('.upsell-options').find('.select option[data-title="'+option+'"]').attr('value');
$(this).parents('.upsell-options').find('[name="id"]').val(id);
});
$(document).on('change', '[name="option1"]', function(){
var option1 = $(this).parents('.upsell-options').find('[name="option1"]').val();
var option2 = $(this).parents('.upsell-options').find('[name="option2"]').val();
var option3 = $(this).parents('.upsell-options').find('[name="option3"]').val();
if(option3 != undefined){
var option = option1 +' / '+ option2 +' / '+ option3;
}else if(option2 != undefined){
var option = option1 +' / '+ option2;
}
else if(option1 != undefined){
var option = option1;
}
var id = $(this).parents('.upsell-options').find('.select option[data-title="'+option+'"]').attr('value');
var price = $(this).parents('.upsell-options').find('.select option[data-title="'+option+'"]').attr('data-price');
var img = $(this).parents('.upsell-options').find('.select option[data-title="'+option+'"]').attr('data-img');
$(this).parents('.upsell-options').find('.upsell-options-variant').text(option);
$(this).parents('.upsell-options').find('.upsell-options-prices .price').text(price);
$(this).parents('.upsell-options').find('.image img').attr('src', img);
$(this).parents('.upsell-options').find('[name="id"]').val(id);
});
$(document).on('change', '[name="option2"]', function(){
var option1 = $(this).parents('.upsell-options').find('[name="option1"]').val();
var option2 = $(this).parents('.upsell-options').find('[name="option2"]').val();
var option3 = $(this).parents('.upsell-options').find('[name="option3"]').val();
if(option3 != undefined){
var option = option1 +' / '+ option2 +' / '+ option3;
}else if(option2 != undefined){
var option = option1 +' / '+ option2;
}
else if(option1 != undefined){
var option = option1;
}
var id = $(this).parents('.upsell-options').find('.select option[data-title="'+option+'"]').attr('value');
var price = $(this).parents('.upsell-options').find('.select option[data-title="'+option+'"]').attr('data-price');
var img = $(this).parents('.upsell-options').find('.select option[data-title="'+option+'"]').attr('data-img');
$(this).parents('.upsell-options').find('.upsell-options-variant').text(option);
$(this).parents('.upsell-options').find('.upsell-options-prices .price').text(price);
$(this).parents('.upsell-options').find('.image img').attr('src', img);
$(this).parents('.upsell-options').find('[name="id"]').val(id);
});
$(document).on('change', '[name="option1"]', function(){
var option1 = $(this).parents('.upsell-options').find('[name="option1"]').val();
var option2 = $(this).parents('.upsell-options').find('[name="option2"]').val();
var option3 = $(this).parents('.upsell-options').find('[name="option3"]').val();
if(option3 != undefined){
var option = option1 +' / '+ option2 +' / '+ option3;
}else if(option2 != undefined){
var option = option1 +' / '+ option2;
}
else if(option1 != undefined){
var option = option1;
}
var id = $(this).parents('.upsell-options').find('.select option[data-title="'+option+'"]').attr('value');
var price = $(this).parents('.upsell-options').find('.select option[data-title="'+option+'"]').attr('data-price');
var img = $(this).parents('.upsell-options').find('.select option[data-title="'+option+'"]').attr('data-img');
$(this).parents('.upsell-options').find('.upsell-options-variant').text(option);
$(this).parents('.upsell-options').find('.upsell-options-prices .price').text(price);
$(this).parents('.upsell-options').find('.image img').attr('src', img);
$(this).parents('.upsell-options').find('[name="id"]').val(id);
});
$(document).on('change', '[name="option3"]', function(){
var option1 = $(this).parents('.upsell-options').find('[name="option1"]').val();
var option2 = $(this).parents('.upsell-options').find('[name="option2"]').val();
var option3 = $(this).parents('.upsell-options').find('[name="option3"]').val();
if(option3 != undefined){
var option = option1 +' / '+ option2 +' / '+ option3;
}else if(option2 != undefined){
var option = option1 +' / '+ option2;
}
else if(option1 != undefined){
var option = option1;
}
$(this).parents('.upsell-options').find('.upsell-options-variant').text(option);
var id = $(this).parents('.upsell-options').find('.select option[data-title="'+option+'"]').attr('value');
$(this).parents('.upsell-options').find('[name="id"]').val(id);
});


$(document).on('click', '.plus-btn-new',function(){
var cval=parseInt($(this).data("val"));
var newval=(cval+1);
var line=parseInt($(this).data("line"));
var sell_id=parseInt($(this).data("subscribe"));
var k=$(this).data("key");
  if(newval < 5){
    if(newval == 1){
  newval=newval + " Tub";
    }else{
  newval=newval + " Tubs";      
    }
      var pid=$(this).data("pid");
  $("#product-select-"+pid + " option").each(function(){
    $(this).attr("selected",false);    
    if($(this).data("title") == newval){
      $(".load-icon-"+line).removeClass("hidden");
      var v=parseInt($(this).val());
     var data = {};
     if(sell_id == 0){
        data={
          "quantity": 1,
          "id":v
        };
        }else{
          data={
              "quantity": 1,
              "selling_plan": sell_id ,
              "id":v
          };
      }
      $(this).attr("selected",true);
        var remove_id = $('.cart-item-edit[data-proid="'+pid+'"]').attr('data-id');
       var values = {}
		values[remove_id] = 0;
        $.ajax({
          type: 'POST', 
          url: '/cart/update.js',
          dataType: 'json', 
          data: {updates: values},
          beforeSend: function( xhr ) {
          },
          success: function() {
                  $.ajax({
                    type: 'POST', 
                    url: '/cart/add.js',
                    dataType: 'json', 
                    data : data,
                    success: function(cart) {
                     carthtmldata();
                    $('.CartItemWrapper').css('transition', 'all 0.6s ease-out');
                    }
                });
          }
        });
        
      
    }
  });
  }
});
$(document).on('click', '.minus-btn-new',function(){
var cval=parseInt($(this).data("val"));
var newval=(cval-1);
var line=parseInt($(this).data("line"));
var sell_id=parseInt($(this).data("subscribe"));
var k=$(this).data("key");
  if(newval > 0){
     if(newval == 1){
      newval=newval + " Tub";
        }else{
      newval=newval + " Tubs";      
        }
  var pid=$(this).data("pid");
  $("#product-select-"+pid + " option").each(function(){
    $(this).attr("selected",false);    
    if($(this).data("title") == newval){
       $(".load-icon-"+line).removeClass("hidden");
     
      var v=parseInt($(this).val());
      var data = {};
      $(this).attr("selected",true);
  
      if(sell_id == 0){
            data={
                "quantity": 1,
                "id":v
            };
       }else{
        data={
          "quantity": 1,
          "selling_plan": sell_id ,
          "id":v
      };
      }
 
        var remove_id = $('.cart-item-edit[data-proid="'+pid+'"]').attr('data-id');
       var values = {}
		values[remove_id] = 0;
        $.ajax({
          type: 'POST', 
          url: '/cart/update.js',
          dataType: 'json', 
          data: {updates: values},
          beforeSend: function( xhr ) {
          },
          success: function() {
                  $.ajax({
                    type: 'POST', 
                    url: '/cart/add.js',
                    dataType: 'json', 
                    data : data,
                    success: function(cart) {
                     carthtmldata();
                    $('.CartItemWrapper').css('transition', 'all 0.6s ease-out');
                    }
                });
          }
        });
        
    }
  });
   }
});

$(document).on('click', '.upsell_var_btn', function(event){
 if (!$(this).parents('.upsell-options').hasClass('cart-edit')) {
  event.preventDefault();
  $('.upsell-options').removeClass('active');
  $('.upsell-options-overlay').removeClass('active');

    var id = $(this).parents('.upsell-options').find('[name="id"]').val();
    var pId = $(this).parents('.upsell-options').find('[name="id"]').attr('data-productid');
    var upCount = $('.why-not-pro-list').length;
    if(upCount == 1 ){
      $('.why-not').slideUp();
    }else{
     $('[data-slidecart-product-id="'+pId+'"]').slideUp();
    }

    var data = {
      "quantity": 1,
      "id": id
    };
    $.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
      data : data,
      success: function(cart) {
       carthtmldata();
      $('.CartItemWrapper').css('transition', 'all 0.6s ease-out');
      }
  });
 }
});

$(document).on('click', '.cart-edit .upsell_var_btn', function(event){
  event.preventDefault();
  console.log("hey");
  var pId = $(this).parents('.upsell-options').find('[name="id"]').attr('data-productid');
  var cart_edit = $(this).parents('.upsell-options').hasClass('cart-edit');
   var id = $(this).parents('.upsell-options').find('[name="id"]').val();
  if(cart_edit === true){
  var remove_id = $('.cart-item-edit[data-proid="'+pId+'"]').attr('data-id');
        values = {}
		values[remove_id] = 0;
        $.ajax({
          type: 'POST', 
          url: '/cart/update.js',
          dataType: 'json', 
          data: {updates: values},
          beforeSend: function( xhr ) {
          },
          success: function() {
                $('.upsell-options').removeClass('active cart-edit');
                $('.upsell-options-overlay').removeClass('active');
              

              
                  var upCount = $('.why-not-pro-list').length;
                  if(upCount == 1 ){
                    $('.why-not').slideUp();
                  }else{
                   $('[data-slidecart-product-id="'+pId+'"]').slideUp();
                  }
              
                  var data = {
                    "quantity": 1,
                    "id": id
                  };
                  $.ajax({
                    type: 'POST', 
                    url: '/cart/add.js',
                    dataType: 'json', 
                    data : data,
                    success: function(cart) {
                     carthtmldata();
                    $('.CartItemWrapper').css('transition', 'all 0.6s ease-out');
                    }
                });
          }
        });

  }

});
